// extracted by mini-css-extract-plugin
module.exports = {"item":"P_c6","item__image":"P_c7","item__title":"P_dn","item__counter":"P_dp","item__active":"P_dq"};